module.exports = __webpack_public_path__ + "static/media/icon-circle-check-web.5925ac9d.svg";